import React from 'react'

import Layout from '../components/layout'
import Head from '../components/head'

const ContactPage = () => {
	return(
		<Layout>
			<Head title="Contact"/>
			<h2>Contact Me</h2>
			<p>Email: bikashthapa.np@gmail.com</p>
		</Layout>
		)
}

export default ContactPage
